import { UseQueryResult, useQuery } from "react-query";

import { useAxios } from "../../hooks/useAxios";

export interface IFetchTopWorkspaceSessionCreatorsParams {
  days_ago: number;
  limit?: number;
}

interface TopWorkspaceSessionCreator {
  user_id: string;
  sessions_count: string;
}

export interface IFetchTopWorkspaceSessionCreatorsResponse {
  top_workspace_class_session_creators: Array<TopWorkspaceSessionCreator>;
}

export default function useFetchTopWorkspaceSessionCreators({
  days_ago,
  limit = 9,
}: IFetchTopWorkspaceSessionCreatorsParams): UseQueryResult<
  IFetchTopWorkspaceSessionCreatorsResponse,
  unknown
> {
  const axios = useAxios();

  const query = useQuery<IFetchTopWorkspaceSessionCreatorsResponse>(
    ["top-workspace-session-creators", { days_ago, limit }],
    async (): Promise<IFetchTopWorkspaceSessionCreatorsResponse> => {
      return await axios
        .get(
          `/v1/workspaces/practice-sets/sessions/top-class-session-creators`,
          {
            params: {
              days_ago,
              limit,
            },
          }
        )
        .then((r) => {
          return r.data as IFetchTopWorkspaceSessionCreatorsResponse;
        });
    }
  );

  return query;
}
